import { useMemo } from "react";

import { getInitials } from "../../utils/getInitials";
import { LogoBrandProps } from "./types";

import styles from "./LogoBrand.module.css";



const LogoBrand = ({
  logoUrl,
  name,
}: LogoBrandProps) => {
  const initials = useMemo(() => getInitials(name), [name]);

  return (
    <div
      className={styles['logo']}
    >
      {!logoUrl ? (
        <div className={styles['logo__fallback']} role="img" aria-label={`${name} logo`}>
          <span className={styles['logo__initials']}>{initials}</span>
        </div>
      ) : (
        <img
          src={logoUrl}
          alt={`${name} logo`}
          className={styles['logo__image']}
          loading="lazy"
        />
      )}
    </div>
  );
};

export default LogoBrand;
